/* ===================================================
   SUPATEA — homepage-only behaviour.

   Cart, variant picking, header and drawer logic all live in
   supatea-editorial.js and are shared site-wide. This file only adds
   behaviour the reconstruction needs on the homepage itself.
   =================================================== */

(function () {
  'use strict';

  function init() {
    var home = document.querySelector('.supatea-home');
    if (!home) return;

    /**
     * The reference composition is a fixed 853-unit canvas. On phones the
     * proportional unit is dropped in CSS and the reviews row becomes a
     * snap-scroller — start it centred on the first card rather than at a
     * half-visible gutter.
     */
    var reviews = home.querySelector('.spt-reviews__grid');
    if (reviews && reviews.scrollWidth > reviews.clientWidth) {
      reviews.scrollLeft = 0;
    }

    /**
     * Guard against a portrait source in the hero: if the merchant uploads a
     * tall image the object-position is nudged so the product stays in frame
     * instead of being cropped through the middle.
     */
    home.querySelectorAll('.spt-hero__media img').forEach(function (img) {
      var apply = function () {
        if (!img.naturalWidth || !img.naturalHeight) return;
        if (img.naturalHeight > img.naturalWidth) {
          img.style.objectPosition = 'center 35%';
        }
      };
      if (img.complete) apply();
      else img.addEventListener('load', apply, { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
